<div class="page-container">
  <div class="page-content">
    <button *ngIf="!(isMinorThanTablet | async).matches" (click)="goToProfilePage()" class="link-btn">
      <mat-icon>arrow_back</mat-icon>
      <span>Voltar</span>
    </button>

    <div class="alert">
      <app-alert [dense]="true" [hideIcon]="true" [type]="'info'" [title]="formTitle[tipoAlteracao]">
      </app-alert>
    </div>

    <p class="escolha-contato">
      Para sua proteção
      <strong>escolha um dos meios de contato</strong>
      abaixo e receba o código para alterar {{ tipoAlteracao === TipoAlteracaoPerfilEnum.SENHA ? 'sua senha' : 'seu perfil'}} com segurança.
    </p>

    <button *ngIf="clientePerfil.email" (click)="selectVerificationMethod(TipoValidacaoCadastral.EMAIL)" mat-stroked-button class="outlined" class="email-viewer">
      <mat-icon class="material-symbols-outlined">email</mat-icon>
      <span class="text-clamp">{{clientePerfil.email}}</span>
    </button>

    <div *ngIf="!clientePerfil.email" class="no-email">
      <p>
        O <strong>e-mail</strong> será usado para recuperar sua conta.
        Caso, por exemplo, você esqueça sua senha.
      </p>
      <div class="link-container">
        <mat-icon class="material-symbols-outlined">email</mat-icon>
        <a class="link" href="javascript:void" (click)="goToProfilePage()">Adicionar e-mail</a>
      </div>
    </div>

    <button mat-stroked-button class="outlined" (click)="selectVerificationMethod(TipoValidacaoCadastral.PHONE)" class="email-viewer">
      <mat-icon class="material-symbols-outlined">smartphone</mat-icon>
      <span>{{clientePerfil.celular | mascara: '(00) 00000-0000' }}</span>
    </button>

    <p class="recuperacao-link">
      {{tipoAlteracao === TipoAlteracaoPerfilEnum.SENHA ? 'Não acessa mais esse e-mail e celular?' : 'Não acessa mais esse e-mail e celular, você pode'}}
      <a class="link" href="javascript:void" (click)="tipoAlteracao === TipoAlteracaoPerfilEnum.SENHA ? goToProfilePage() : goToAccountConfirmationPage()">
        {{tipoAlteracao === TipoAlteracaoPerfilEnum.SENHA ? 'Clique aqui' : 'tentar de outro jeito'}}
      </a>
      <span *ngIf="tipoAlteracao === TipoAlteracaoPerfilEnum.SENHA">para alterar</span>
    </p>

  </div>
</div>